var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOpe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 205,
    viewBox: "60 26 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0.089,
    x2: 0.5,
    y2: 0.905,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FF",
    offset: 0.081
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003AE9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0.089,
    x2: 0.5,
    y2: 0.905,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF2A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2AC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.13,
    y1: 0.112,
    x2: 0.865,
    y2: 0.883,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FF",
    offset: 0.104
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2AC9",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.166 15.056c0-8.297-6.704-15.001-15-15.001-8.298 0-15.001 6.704-15.001 15v96.817c0 8.298 6.703 15.001 15 15.001s15.001-6.703 15.001-15V15.055Z",
    fill: "url(#a)",
    transform: "matrix(.52222 0 0 .52222 81.246 40.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.279 15.275c0-8.297-6.704-15-15-15-8.298 0-15.001 6.703-15.001 15v96.817c0 8.297 6.703 15 15 15s15.001-6.703 15.001-15V15.275Z",
    fill: "url(#b)",
    transform: "matrix(.52222 0 0 .52222 81.246 40.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.76 5.495C21.483-.88 11.977-1.758 5.604 3.517c-6.374 5.275-7.308 14.725-2.033 21.1 2.527 3.021 77.585 93.96 80.113 97.036 5.275 6.374 14.725 7.308 21.154 2.033 6.374-5.275 7.308-14.726 2.033-21.155-2.527-3.022-77.64-93.96-80.113-97.036Z",
    fill: "url(#c)",
    transform: "matrix(.52222 0 0 .52222 81.246 40.4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOpe);
export default __webpack_public_path__ + "static/media/logo_ope.8789769f411d6b338aca1ae0d9fd01ed.svg";
export { ForwardRef as ReactComponent };